import { Card, Badge } from '@aimsos/ui';

const SECTION_LABEL = 'text-[11px] font-semibold uppercase tracking-wide text-content-faint';

/** Uppercase label + value row for the integration-details sidebar. */
function DetailField({ label, children }) {
  return (
    <div className="flex flex-col gap-1 py-3 first:pt-0 last:pb-0">
      <dt className={SECTION_LABEL}>{label}</dt>
      <dd className="text-sm text-content">{children}</dd>
    </div>
  );
}

/**
 * "Integration details" sidebar — maintainer, version, docs and the compliance
 * posture (support, data residency, compliance chips, last security review).
 * Fields are divider-separated, as in the prototype.
 */
function DetailsSidebar({ t, details }) {
  return (
    <aside className="w-full lg:w-72">
      <Card>
        <Card.Body>
          <h3 className="mb-2 text-sm font-semibold text-content">
            {t('integrations.provider.overview.details')}
          </h3>
          <dl className="flex flex-col divide-y divide-edge">
            <DetailField label={t('integrations.provider.overview.maintainer')}>
              {details.maintainer}
            </DetailField>
            <DetailField label={t('integrations.provider.overview.version')}>
              <span className="inline-flex items-center gap-1.5">
                {details.version}
                {details.changelog_url && (
                  <>
                    <span className="text-content-faint">·</span>
                    <a href={details.changelog_url} className="text-accent hover:underline">
                      {t('integrations.provider.overview.changelog')}
                    </a>
                  </>
                )}
              </span>
            </DetailField>
            {details.docs_url && (
              <DetailField label={t('integrations.provider.overview.documentation')}>
                <a href={details.docs_url} className="text-accent hover:underline">
                  {t('integrations.provider.overview.docs')}
                </a>
              </DetailField>
            )}
            {details.support_email && (
              <DetailField label={t('integrations.provider.overview.support')}>
                <a href={`mailto:${details.support_email}`} className="hover:underline">
                  {details.support_email}
                </a>
              </DetailField>
            )}
            {details.data_residency && (
              <DetailField label={t('integrations.provider.overview.dataResidency')}>
                {details.data_residency}
              </DetailField>
            )}
            {details.compliance?.length > 0 && (
              <DetailField label={t('integrations.provider.overview.compliance')}>
                <span className="flex flex-wrap gap-1.5">
                  {details.compliance.map((c) => (
                    <Badge key={c} variant="neutral" size="small" radius="full">
                      {c}
                    </Badge>
                  ))}
                </span>
              </DetailField>
            )}
            {details.security_review && (
              <DetailField label={t('integrations.provider.overview.lastSecurityReview')}>
                {details.security_review}
              </DetailField>
            )}
          </dl>
        </Card.Body>
      </Card>
    </aside>
  );
}

export default DetailsSidebar;
